import React, { useState, useEffect } from "react";
import axios from "axios";
import "../assets/expo_landing_page.css";

import rp from '../assets/imgs/RiverParadise/rp3.png';
import tamhini from '../assets/imgs/Banner/tamhini_.png';
import vatika from '../assets/imgs/Banner/aatmabodh_vatika.png';
import lonavalley from "../assets/imgs/lonavalley-3.webp";
import Sawali from '../assets/imgs/Banner/sawali_plots.png';
import county from '../assets/imgs/home.webp';


export default function ExpoLandingPage() {

    const [form, setForm] = useState({
        name: "",
        mobile: "",
        city: "",
        budget: "",
        project: ""   // ✅ NEW
    });

    const [loading, setLoading] = useState(false);

    // Scroll animation
    useEffect(() => {
        const elements = document.querySelectorAll(".fade-up");

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                }
            });
        }, { threshold: 0.2 });

        elements.forEach((el) => observer.observe(el));
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.mobile.length !== 10) {
            alert("Enter valid mobile number");
            return;
        }

        if (!form.project) {
            alert("Please select a project");
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(
                "https://samriddhidevelopers.in/backend/expo_lead.php",
                form,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.status === "success") {

                const message = `Hi, I am ${form.name}. Interested in: ${form.project}. Budget: ${form.budget}. I visited Sakal Vastu Expo and want details.`;

                const encoded = encodeURIComponent(message);

                setTimeout(() => {
                    window.location.href = `https://wa.me/919766010099?text=${encoded}`;
                }, 800);

            } else {
                alert("Failed to save lead");
            }

        } catch (err) {
            console.error(err);
            alert("Server error");
        }

        setLoading(false);
    };

    return (
        <div className="expo-page">

            {/* HERO */}
            <section className="expo-hero">
                <div className="expo-overlay">
                    <h1 className="expo-heading fade-up">
                        Discover Premium Land Investments Near Pune
                    </h1>

                    <p className="expo-sub fade-up">
                        Farmhouse Plots • Waterfront Living • Wellness Communities
                    </p>

                    <div className="expo-strip fade-up">
                        Sakal Vastu Expo | 11–12 April | Pandit Farm
                    </div>

                    <button
                        className="expo-primary-btn fade-up"
                        onClick={() =>
                            document.getElementById("expo-projects").scrollIntoView({ behavior: "smooth" })
                        }
                    >
                        Explore Projects
                    </button>
                </div>
            </section>

            {/* PROJECTS */}
            <section id="expo-projects" className="expo-projects">
                <h2 className="section-title fade-up">Explore Our Projects</h2>

                <div className="expo-grid">
                    {projects.map((p, i) => (
                        <div
                            key={i}
                            className={`expo-card fade-up ${form.project === p.name ? "selected" : ""}`}
                            onClick={() => setForm({ ...form, project: p.name })}
                        >
                            <img src={p.img} alt={p.name} className="expo-card-img" />
                            <h3>{p.name}</h3>
                            <p>{p.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* FORM */}
            <section className="expo-form-section">
                <h2 className="expo-section-title-white fade-up">
                    Get Price, Brochure & Site Visit
                </h2>

                <form className="expo-form fade-up" onSubmit={handleSubmit}>

                    {/* SELECT PROJECT */}
                    <select name="project" value={form.project} onChange={handleChange} required>
                        <option value="">Select Interested Project</option>
                        {projects.map((p, i) => (
                            <option key={i} value={p.name}>{p.name}</option>
                        ))}
                    </select>

                    <input name="name" placeholder="Your Name" onChange={handleChange} required />
                    <input name="mobile" placeholder="Mobile Number" onChange={handleChange} required />
                    <input name="city" placeholder="City" onChange={handleChange} required />

                    <select name="budget" onChange={handleChange} required>
                        <option value="">Select Budget</option>
                        <option>30–50L</option>
                        <option>50–80L</option>
                        <option>80L+</option>
                    </select>

                    <button type="submit" className="expo-primary-btn" disabled={loading}>
                        {loading ? "Submitting..." : "Unlock Details on WhatsApp"}
                    </button>
                </form>
            </section>

            {/* FOOTER */}
            <footer className="expo-footer">
                Visit us at Pandit Farm | Sakal Vastu Expo
            </footer>

        </div>
    );
}

// PROJECT DATA
const projects = [
    { name: "River Paradise – Mulshi", desc: "Waterfront Living", img: rp },
    { name: "Majestic Falls – Tamhini", desc: "Waterfall Views", img: tamhini },
    { name: "Aatamabodh Vatika – Donje", desc: "Wellness Living", img: vatika },
    { name: "Lonavalley", desc: "Resort Lifestyle", img: lonavalley },
    { name: "Sawali Kondhanpur", desc: "R-Zone Society", img: Sawali },
    { name: "Samriddhi Rich County", desc: "2.5 BHK Homes", img: county },
];